import { useState, useEffect, useRef} from 'react';
import './classes/MyCredentialsDetailView.css';
import { configData } from "../config";
import Loading from './Loading';
import { useParams } from 'react-router-dom';
import html2canvas from "html2canvas";
import { Helmet } from 'react-helmet';

const MyCredentialsDetailView = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [certificates, setCertificates] = useState([]);
	const [shareUrl, setShareUrl] = useState('');
	const [shareText, setShareText] = useState('');
	const [activeView, setActiveView] = useState("certificate");
	  const showCertificate = () => {
    if (activeView !== "certificate") {
      setActiveView("certificate");
    }
  };

  const showBadge = () => {
    if (activeView !== "badge") {
      setActiveView("badge");
    }
  };

	const [isBadgeOpen, setIsBadgeOpen] = useState(false);

     var {slug} = useParams();
	 var {drupal_uid} = useParams();
	  var {sku} = useParams();
	  var {classid} = useParams();

	  const app_url = configData.APP_URL;
   useEffect(() => {
   retrieveUserCertificateDetailView(); 

  const timer = setTimeout(() => {
    setIsLoading(false);
  }, 800);

  return () => clearTimeout(timer);
}, []);
 async function retrieveUserCertificateDetailView() {
    
    if(drupal_uid && !Number.isNaN(drupal_uid)) {
    const response = await fetch(
      app_url+'certificate/getcertificatedetailview?uid='+drupal_uid+'&sku='+sku+'&classid='+classid,
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
     setCertificates(responsedata.data.details);
	 setShareUrl(responsedata.data.details.shareurl);
	 setShareText(responsedata.data.details.sharetext);
    }
  }
  }
      useEffect(() => {
  const certificateData = [
    {
      id: 1,
      certificateImg: "https://www.smwwearena.com/certificates/image/14347_37467-1.png",
      certificateSmallImg: "https://www.smwwearena.com/certificates/image/14347_37467-1.png",
      badgeImg: "https://www.smwwearena.com/admin/badge_image.png",
      badgeText: "TestNewcourse Newcourse",
      userImage: "https://www.smwwearena.com/userphoto/f8b69e6156999b84137f3f0a23701b75_14347.jpg",
      userName: "GayaTest GayathriTest",
      courseName: "TestNewcourse Newcourse Course",
      issuedOn: "Jul 14, 2025",
      expiresOn: "Does not expire"
    },
  ];
//setCertificates(certificateData);
  }, []);
  //const shareUrl = "https://www.sportsmanagementworldwide.com/certificate/gayatest-gayathritest/658273/course/SPORTS/3833";
//const shareText = "Just earned my TestNewcourse Newcourse Course certificate from SMWW!";

const downloadBadge = async () => {
  const element = document.getElementById("badge-download-area");

  // Wait for fonts
  await document.fonts.ready;

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: null
  });

  const link = document.createElement("a");
  link.download = "badge.png";
  link.href = canvas.toDataURL("image/png");
  link.click();
};

     
     return ( 
        <>
         {isLoading ? (
                    <Loading />
                ) : (
            <div id="main" className="certificate-detail-view">
              {certificates.map((data) => (
                <>
                 <Helmet>
                    <title>
                        {/* {getPageTitle()} */}
                        {data.courseName+" | "+data.userName+" | SMWW"}
                    </title>
                </Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="certificate-container" style={{marginTop:"16px"}}>
	{/* <div style={{"background": "#dedede","marginBottom": "4%"}}>
		<div className="certificate-img-container" style={{"textAlign":"center"}}>
			<div className="certificate-img-wrapper">
				<img id="certificate_img" className="certificate-img" src={data.certificateImg}/>
				<div id="badge_img" className="badge-img" style={{"display": "none","width": "56.5%","position": "relative"}}>
					<img src={data.badgeImg} style={{"width":"60%"}}/>
					<div className="badge-img-content">
												<span dangerouslySetInnerHTML={{ __html: data.badgeText }} />
											</div>
				</div>
			<div className="certificate-small-img-wrapper">
				<img id="certificate_small_img" className="certificate-small-img  active-img" src={data.certificateSmallImg}/>
				<div id="certificate_badge_img" className="certificate-badge-img" style={{"display": "inline-block","position": "relative"}}>
					<img src={data.badgeImg}/>
					<div className="badge-thumbnail-content">
												<span dangerouslySetInnerHTML={{ __html: data.badgeText }} />
											</div>
				</div>
			</div>
			</div>
		</div>
	</div> */}
	    <div style={{ background: "#dedede", marginBottom: "4%" }}>
      <div className="certificate-img-container" style={{ textAlign: "center" }}>
        <div className="certificate-img-wrapper">

          {/* CERTIFICATE IMAGE */}
          {activeView === "certificate" && (
            <img
              className="certificate-img"
              src={data.certificateImg}
              alt="Certificate"
            />
          )}

          {/* BADGE IMAGE */}
          {activeView === "badge" && (
            <div className="badge-img main-badge-img">
              <img src={data.badgeImg} style={{ width: "60%" }} />
              <div className="badge-img-content">
                <span dangerouslySetInnerHTML={{ __html: data.badgeText }} />
              </div>
            </div>
          )}

          {/* THUMBNAILS */}
          <div className="certificate-small-img-wrapper">
            <img
              className={`certificate-small-img ${
                activeView === "certificate" ? "active-img" : ""
              }`}
              src={data.certificateSmallImg}
              onClick={showCertificate}
              alt="Certificate thumbnail"
            />

            <div
              className={`certificate-badge-img ${
                activeView === "badge" ? "active-img" : ""
              }`}
              onClick={showBadge}
              style={{ position: "relative", display: "inline-block" }}
            >
              <img src={data.badgeImg} />
              <div className="badge-thumbnail-content">
                <span dangerouslySetInnerHTML={{ __html: data.badgeText }} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

	<div className="top-section-container">
	
		<div className="homepage-url-section">
			<img className="certificate--img" src="/basic/web/images/new_logo.png" width="50"/> 
			<span className="homepage-link">
				<a href={`${configData.DRUPAL_DOMAIN_URL}/`}>Sports Management Worldwide&nbsp;</a>
			</span>
		</div>

		<div className="certificate-course-name">
			<h1 style={{"fontSize": "24px","fontWeight": 600,"color":"#003c7d","border":"none","padding":0}}>
			{data.courseName}			</h1>
		</div>

		<div className="certificate-course-social">			
			<a target="_blank" href={data.download_pdf_url}><span className="pdf-icon">DOWNLOAD CERTIFICATE</span></a>
			<span id="myBtn" className="badge-icon" style={{"fontSize": "13px","color":"#3366bb","marginLeft": "3%","cursor": "pointer"}} onClick={() => setIsBadgeOpen(true)}>DOWNLOAD BADGE</span>
			{isBadgeOpen && (
  <div className="badge-modal-overlay" onClick={() => setIsBadgeOpen(false)}>
    <div className="badge-modal">
      
      <span
        className="badge-close"
        onClick={() => setIsBadgeOpen(false)}
      >
        ✕
      </span>

      <div className="badge-modal-content">
		{/* <div id="badge-download-area">
        <img src="/images/badge_image.png" className="badge-modal-img"  />

        <div className="badge-img-content">
          <span className="download-badge-text" dangerouslySetInnerHTML={{ __html: data.badgeText }}  />
    
        </div>
		</div> */}
		<div
  id="badge-download-area"
  className="badge-download-canvas"
>
  <img src="/basic/web/images/badge_image.png" className="badge-modal-img" />

  <div className="badge-img-content">
    <span
      className="download-badge-text"
      dangerouslySetInnerHTML={{ __html: data.badgeText }}
    />
  </div>
</div>


        <button className="badge-download-btn" onClick={downloadBadge}>
          Download
        </button>
      </div>
    </div>
  </div>
)}

			<a href={"mailto:?subject="+data.subject+"&body="+data.body}><span class="email-icon">EMAIL</span></a>
		</div>

		<div>
			<div className="certificate-user-wrapper">
				<div className="certificate-user-img-wrapper">
					<img className="certificate-user-img" src={data.userImage}/>
				</div>
				<div>
					<h2 style={{"margin": "6% 0 6% 0","fontSize":"22px","color":"#003c7d"}}>{data.userName}</h2>
					<span className="credentials-link">
						<a href={"/user/"+drupal_uid+"/certificate"}>View All Credentials</a>
					</span>
				</div>
			</div>
		</div>

		<hr/>
		
		<div style={{"margin": "2% 0","lineHeight": "20px","fontSize":"16px","marginLeft":"1px"}}>
				Sports Management Worldwide Soccer Agency is an international full-service soccer agency with an extensive network of Agent Advisors serving soccer players throughout the world. 
		The Best of Both Worlds Sports Management Worldwide Soccer Agency provides a "two-for-one" Agent approach. SMWW partners a personalized, enthusiastic, passionate, newly 
		trained Agent Advisor with a highly experienced, certified veteran Agent.
					</div>

		<div>&nbsp;</div>

		<div>
			<table class="certificate-date-table" style={{"width":"100%","fontSize":"16px"}}>
				<tbody>
					<tr>
						<td class="certificate-issued-date"><span>ISSUED ON</span><br/>
						<br/>
							<span>{data.issuedOn}</span>
						</td>
						<td class="certificate-expired-date"><span>EXPIRES ON</span><br/>
						<br/>
							<span>{data.expiresOn}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	
	</div>

	<div className="bottom-section-container">
	
		<div className="socail-media-container">
			<div style={{"display":"flex","marginBottom":"6%","justifyContent": "space-between"}}>
				<div style={{"margin": "0 4% 0 0"}}>
					<div class="share-credentials" style={{"fontSize":"22px"}}>
						<h2 style={{"margin":"2% 0","color":"#fff"}}>Share Credentials</h2>
						<span style={{"fontSize":"14px"}}>Show this credential on your social network</span>
					</div>
				</div>
			<div>
				<img className="certificate-social-badge-img" src="/basic/web/images/certificate-badge.jpg"/>
			</div>
			</div>

			
            <div className="social-media-wrapper">

  {/* LinkedIn */}
  <a
    target="_blank"
    href={data.linkedin_url}
  >
    <img className="certificate-social-media-img" src="/basic/web/images/linkedin-logo.png" width="20" />
  </a>

  {/* Facebook */}
  <a
    target="_blank"
    href={data.facebook_url}
  >
    <img className="certificate-social-media-img" src="/basic/web/images/facebook-logo.png" width="20" />
  </a>

  {/* Twitter (X) */}
  <a
    target="_blank"
    href={data.twitter_url}
  >
    <img className="certificate-social-media-img" src="/basic/web/images/twitter-logo.png" width="20" />
  </a>

  {/* WhatsApp */}
  <a
    target="_blank"
    href={data.whatsapp_url}
  >
    <img className="certificate-social-media-img" src="/basic/web/images/whatsapp-logo.png" width="20" />
  </a>

</div>


		<div class="Add_linkedin_container" style={{"color": "#2c69c1","background":"#fff","borderRadius":"5px","textAlign": "center"}}>
			<a target="_blank" href={data.addto_profile_link}>
				<img class="certificate-linkedin-profile-img" src="/basic/web/images/linkedin_logo_icon.png" width="20"/>
				<span style={{"color": "#2c69c1"}}>Add to My Linkedin Profile</span>
			</a>
		</div>
		</div>

		<div style={{"margin": "10% 0"}}>
			<div style={{"border": "1px solid #d2d4d4","textAlign": "center","fontWeight": 600,"fontSize": "16px","background-color": "#e6ad59","borderRadius": "5px","borderColor": "#cb8b35"}}>
							<a target="_blank" href={`${configData.DRUPAL_DOMAIN_URL}/courses`} style={{"color":"#fff","fontSize": "16px"}}>
					<span style={{"padding": "15px","display":"block"}}>View Course Page</span>
				</a>
			</div>
		</div>
		
		<div style={{"backgroundColor": "#fff","padding": "10% 8%","lineHeight": "20px","border": "1px solid #d2d4d4"}}>
			<div style={{"textAlign": "center"}}>
				<img src="/basic/web/images/smww_iconlogo.png" width="150"/>
			</div>
		
			<div style={{"fontSize": "16px","marginTop":"20px"}}>
				Sports Management Worldwide (SMWW) is the global leader in online sports business education, offering courses, degrees, and conferences to a world audience. Proudly serving more than 30,000 alumni from 163 different countries, SMWW seeks to connect all of those who have a passion for sports with industry leaders.
			</div>
		</div>
		
	</div>
</div>
                    
              </div>
              <div className='right'></div>
            </>
          ))}
        </div>     
      )}
    </>
  );
};

export default MyCredentialsDetailView;